export { dataHooks, type DataHooks } from './dataHooks';
export {
  SettingsEventsKeys,
  ForcedState,
  type SettingsEvents,
} from './settings';
export { CONDUCTOR_FT } from './featureToggles';

export const MEMBERS_V2_NAMESPACE = 'members-v2';

export const IDP_APPDEFIDS = {
  facebook: '3ecad13f-52c3-483d-911f-31dbcf2a6d23',
  google: '0e6a50f5-b523-4e29-990d-f37fa2ffdd69',
  sso: '4f199cbe-22ee-40c8-9129-11f2b4178a38',
};

export const PASSWORD_CONNECTION_APPDEFID =
  '31fff8fc-ea95-43ac-95c5-902497125b90';

// AppDefIds of connections to hide from social buttons section
export const HIDDEN_CONNECTION_APPDEFIDS = new Set([
  PASSWORD_CONNECTION_APPDEFID,
]);

export const TEXT_DIRECTION = {
  RTL: 'rtl',
  LTR: 'ltr',
} as const;
